import type { MassIncidentSummary } from '@/shared/api';
import { pluralRu } from '@/shared/lib/plural';
import type { PickerRequest } from './store';

function formatSince(iso: string, now: Date): string {
  const d = new Date(iso);
  const time = d.toLocaleTimeString('ru', { hour: '2-digit', minute: '2-digit' });
  if (d.toDateString() === now.toDateString()) return `с ${time}`;
  return `с ${d.toLocaleDateString('ru', { day: '2-digit', month: '2-digit' })} ${time}`;
}

export function incidentMeta(s: MassIncidentSummary, now = new Date()): string {
  const parts = [
    s.status === 'resolved' ? 'Устранён' : s.auto ? 'Правилом' : 'Вручную',
    formatSince(s.createdAt, now),
    `${s.ticketsTotal} ${pluralRu(s.ticketsTotal, 'заявка', 'заявки', 'заявок')}`,
  ];
  if (s.ticketsOpen !== s.ticketsTotal) {
    parts.push(`${s.ticketsOpen} ${pluralRu(s.ticketsOpen, 'открыта', 'открыты', 'открыто')}`);
  }
  return parts.join(' · ');
}

function affinity(i: MassIncidentSummary, req: PickerRequest): number {
  if (req.subcategoryId && i.subcategoryIds.includes(req.subcategoryId)) return 2;
  if (req.categoryId && i.categoryIds.includes(req.categoryId)) return 1;
  return 0;
}

export function rankIncidents(
  list: MassIncidentSummary[],
  req: PickerRequest,
  query: string,
): MassIncidentSummary[] {
  const q = query.trim().toLocaleLowerCase('ru');
  return list
    .filter((i) => i.id !== req.currentIncidentId)
    .filter((i) => !q || i.title.toLocaleLowerCase('ru').includes(q))
    .sort((a, b) => affinity(b, req) - affinity(a, req) || b.createdAt.localeCompare(a.createdAt));
}

export function replyRecipients(
  liveIds: string[],
  selected: ReadonlySet<string>,
): { ticketIds: string[]; all: boolean } {
  const ticketIds = liveIds.filter((id) => selected.has(id));
  return { ticketIds, all: ticketIds.length === liveIds.length };
}
